import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 榜单类型
export enum PageTypeEnum {
  年度公会,
  年度神豪,
  年度国家,
}
// 公会榜单类型
export enum UnionRankTypeEnum {
  日榜,
  总榜,
}

// 规则页面 http://wiki.xunlei.cn/pages/viewpage.action?pageId=151082665
export const getRulesPage = createAsyncThunk(
  '/live/activity/annual_rules_page',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/annual_rules_page',
      {},
      {
        store,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 赛程安排
type ScheduleItem = {
  status: number // 状态（0未完成 1进行中 2已完成）
  total: number // 几进几（前者）
  limit: number // 几进几（后者）
  year: number
  month: number
  day: number
  race_id: number // 赛事id
  title: string // 标题 几进几文案
  desc: string // 描述 状态文案
}
interface InitialStateType {
  rankType: number // 榜单类型
  preCountdown?: number // 预热倒计时
  schedule?: Array<ScheduleItem> // 赛程安排
  isRefresh: boolean // 是否刷新当前榜单
}

const initialState: InitialStateType = {
  rankType: PageTypeEnum.年度公会,
  isRefresh: false,
}

export const AnnualActivity2024Slice = createSlice({
  name: 'AnnualActivity2024',
  initialState,
  reducers: {
    // 设置当前榜单
    setRankType: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        ...state,
        rankType: action.payload,
      })
    },
    // 设置当前榜单
    setIsRefresh: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        ...state,
        isRefresh: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRulesPage.fulfilled, (state, action) => {
      Object.assign(state, {
        preCountdown: action.payload?.countdown,
        schedule: action.payload?.schedule,
      })
    })
  },
})
export default AnnualActivity2024Slice.reducer
export const AnnualActivity2024Actions = AnnualActivity2024Slice.actions
